import useFacebookAuth from 'Pages/facebookManament/hooks/useFacebookAuth'
import {FacebookLayoutGeneral} from 'Pages/facebookManament/layouts/general'
import FacebookService from 'Pages/facebookManament/services'
import {useEffect, useRef} from 'react'
import {useReducer} from 'react'
import {PageFacebookLogin} from '../login'
import {FacebookMessageConfirmOrderProvider} from './provider'
import {facebookMessageConfirmOrderInitialState} from './provider/_initstate'
import {FacebookMessageConfirmOrderReducer} from './provider/_reducer'
import {useTranslation} from 'react-i18next'
import {EditContent} from './components/content'
import {LivestreamContent} from './components/livestreamContent'
import {Button} from '../../../../common/button'
import useFacebookMessageConfirmOrder from './hooks/useFacebookMessageConfirmOrder'
import {useParams, useNavigate} from 'react-router-dom'
import {Switch} from '../../../../common/switch'
import useGlobalContext from 'containerContext/storeContext'

export const PageFacebookMessageConfirmOrderEdit = () => {
  const [state, dispatch] = useReducer(
    FacebookMessageConfirmOrderReducer,
    facebookMessageConfirmOrderInitialState,
  )

  return (
    <FacebookMessageConfirmOrderProvider value={{state, dispatch}}>
      <PageContainer />
    </FacebookMessageConfirmOrderProvider>
  )
}

const PageContainer = () => {
  const params = useParams()
  const navigate = useNavigate()
  const {t} = useTranslation()
  const {facebookAuth, logout, getUser, setAuthData} = useFacebookAuth()
  const {auth} = facebookAuth
  const {data, methods} = useFacebookMessageConfirmOrder()
  const {status} = data.detail
  const {status: livestreamStatus} = data.livestreamDetail
  const isDataLoaded = data.isDataLoaded
  const [, GlobalDispatch] = useGlobalContext()
  const initialDataRef = useRef(null)

  useEffect(() => {
    FacebookService.initFacebookSdk({
      getAuthData: data => setAuthData(data),
    })
  }, [])

  useEffect(() => {
    document.title = t('editConfirmMessage')
    if (auth.userId) getUser()
  }, [auth.userId])

  useEffect(() => {
    if (auth.userId && params?.pageId) {
      methods.fetchDetail(params.pageId)
    }
  }, [auth.userId, params?.pageId])

  useEffect(() => {
    if (
      isDataLoaded &&
      data.detail.content_message &&
      data.livestreamDetail.content_message &&
      !initialDataRef.current
    ) {
      initialDataRef.current = {
        detail: JSON.stringify(data.detail.content_message),
        livestreamDetail: JSON.stringify(data.livestreamDetail.content_message),
        detailStatus: data.detail.status,
        livestreamStatus: data.livestreamDetail.status,
      }
    }
  }, [
    isDataLoaded,
    data.detail.content_message,
    data.livestreamDetail.content_message,
    data.detail.status,
    data.livestreamDetail.status,
  ])

  useEffect(() => {
    if (!initialDataRef.current || !isDataLoaded) return

    const currentData = {
      detail: JSON.stringify(data.detail.content_message),
      livestreamDetail: JSON.stringify(data.livestreamDetail.content_message),
      detailStatus: data.detail.status,
      livestreamStatus: data.livestreamDetail.status,
    }

    const hasChanged =
      currentData.detail !== initialDataRef.current.detail ||
      currentData.livestreamDetail !==
        initialDataRef.current.livestreamDetail ||
      currentData.detailStatus !== initialDataRef.current.detailStatus ||
      currentData.livestreamStatus !== initialDataRef.current.livestreamStatus

    GlobalDispatch({
      type: 'UPDATE_CHANGE_STATUS',
      payload: {
        status: hasChanged,
        link: '/facebook/message-confirm-order',
        showPopup: false,
      },
    })
  }, [
    isDataLoaded,
    data.detail.content_message,
    data.livestreamDetail.content_message,
    data.detail.status,
    data.livestreamDetail.status,
    GlobalDispatch,
  ])

  if (auth.userId)
    return (
      <FacebookLayoutGeneral
        title={t('facebookManament_configuration_setup')}
        subTitle=" "
        isUl={true}
        breadcrumb={[
          {
            id: 1,
            name: t('back'),
            url: '/facebook/message-confirm-order',
            isBack: true,
          },
        ]}
        authData={facebookAuth}
        logout={logout}
      >
        <style>{`
                    .grid-layout__section-header {
                        margin-bottom: 0 !important;
                    }
                `}</style>
        <div
          style={{
            display: 'flex',
            gap: 24,
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          }}
        >
          <div style={{width: '615px'}}>
            {isDataLoaded && (
              <>
                <div style={{marginBottom: 32}}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      marginBottom: 16,
                    }}
                  >
                    <Switch
                      checked={+status === 1}
                      onChange={methods.onChangeMessageStatus}
                    />
                    <span
                      style={{fontSize: 18, fontWeight: 600, color: '#00081D'}}
                    >
                      {t('deliverySuccessConfirmMessage')}
                    </span>
                  </div>
                  <div style={{display: +status === 1 ? 'block' : 'none'}}>
                    <EditContent />
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      marginBottom: 16,
                    }}
                  >
                    <Switch
                      checked={+livestreamStatus === 1}
                      onChange={methods.onChangeLivestreamStatus}
                    />
                    <span
                      style={{fontSize: 18, fontWeight: 600, color: '#00081D'}}
                    >
                      {t('livestreamQuickOrderConfirmMessage')}
                    </span>
                  </div>
                  <div style={{display: +livestreamStatus === 1 ? 'block' : 'none'}}>
                    <LivestreamContent />
                  </div>
                </div>
              </>
            )}
          </div>

          <div
            style={{
              position: 'sticky',
              top: 24,
              display: 'flex',
              gap: 12,
              alignItems: 'flex-start',
            }}
          >
            <Button
              size={'md-'}
              appearance="ghost"
              style={{width: 72}}
              onClick={() => {
                GlobalDispatch({
                  type: 'UPDATE_CHANGE_STATUS',
                  payload: {
                    status: false,
                    link: '/facebook/message-confirm-order',
                    showPopup: false,
                  },
                })
                navigate('/facebook/message-confirm-order')
              }}
            >
              {t('general_cancel')}
            </Button>
            <Button
              size={'md-'}
              style={{minWidth: 110}}
              onClick={() => {
                methods.onSubmit(params?.pageId)
              }}
            >
              {t('save')}
            </Button>
          </div>
        </div>
      </FacebookLayoutGeneral>
    )

  return <PageFacebookLogin connect={setAuthData} />
}
